module.exports = __webpack_public_path__ + "img/cocteleria_3.1eac9f0b.jpeg";